import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { CaptureSearchParamSet } from '../models/capture-search-param-set.model';
import { CaptureSearchResult } from '../models/capture-lists/capture-search-result.model';
import { environment } from '../../../environments/environment';
import { LimitOffsetPaging, LimitOffsetPagingMeta, Paging } from '../models/paged-results/limit-offset-paging.model';

// IMPORTANT: for the capture search service used by capture admins see CaptureQueueService
export class PagedCaptureSearchResults implements PagedResults<CaptureSearchResult> {
  captures: CaptureSearchResult[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.captures;
  }

  static get empty(): PagedCaptureSearchResults {
    const pagedCaptures = new PagedCaptureSearchResults();
    pagedCaptures.captures = new Array<CaptureSearchResult>();
    pagedCaptures.meta = new LimitOffsetPagingMeta();
    pagedCaptures.meta.paging = LimitOffsetPaging.empty;
    return pagedCaptures;
  }
}

@Injectable()
export class CaptureSearchService extends ApiService {
  private http = inject(HttpClient);

  search(
    captureSearchParams: CaptureSearchParamSet,
    paging: Paging = { pageSize: 'all' }
  ): Observable<PagedCaptureSearchResults> {
    const queryParams: any = this.toParams(captureSearchParams);

    if (paging.page) {
      queryParams.page = paging.page;
    }

    if (paging.pageSize) {
      queryParams.per_page = paging.pageSize;
    }

    return this.http.get<PagedCaptureSearchResults>(`${environment.captureApi.url}/captures/search`, {
      params: queryParams,
    });
  }

  getSavedSearchParams(): Observable<CaptureSearchParamSet> {
    return this.http.get<CaptureSearchParamSet>(`${environment.captureApi.url}/me/capture_search_param_set`);
  }

  saveSearchParams(captureSearchParams: CaptureSearchParamSet) {
    return this.http.patch<void>(`${environment.captureApi.url}/me/capture_search_param_set`, captureSearchParams);
  }
}
